var map = {
	"./favicon-32x32.png": [
		191
	],
	"./icon-accessibility.svg": [
		81,
		81
	],
	"./icon-correct.svg": [
		199,
		199
	],
	"./icon-css.svg": [
		480,
		480
	],
	"./icon-error.svg": [
		158,
		158
	],
	"./icon-html.svg": [
		429,
		429
	],
	"./icon-incorrect.svg": [
		842,
		842
	],
	"./icon-js.svg": [
		188,
		188
	],
	"./icon-moon-dark.svg": [
		974,
		974
	],
	"./icon-moon-light.svg": [
		962,
		962
	],
	"./icon-sun-dark.svg": [
		756,
		756
	],
	"./icon-sun-light.svg": [
		385,
		385
	],
	"./pattern-background-desktop-dark.svg": [
		742,
		742
	],
	"./pattern-background-desktop-light.svg": [
		447,
		23
	],
	"./pattern-background-mobile-dark.svg": [
		614,
		614
	],
	"./pattern-background-mobile-light.svg": [
		309,
		309
	],
	"./pattern-background-tablet-dark.svg": [
		461,
		461
	],
	"./pattern-background-tablet-light.svg": [
		407,
		407
	],
	"./preview.jpg": [
		654
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 712;
module.exports = webpackAsyncContext;